import { NgModule, Pipe, PipeTransform } from '@angular/core';



@Pipe({
  name: 'tugrug'
})
export class TugrugPipe implements PipeTransform {
  transform(amount: number): string {
    const s = amount.toString();
    if (s.length <= 3) {
      return s + '₮';
    }
    const groups = Math.ceil(s.length / 3);

    const arr = [];
    const rem = s.length % 3;
    let err = 0;
    if (rem !== 0) {
      arr.push(s.substring(0, rem));
      err = -1;
    }

    for (let i = 0; i < groups + err; i++) {
      arr.push(s.substring(rem + i * 3, rem + (i + 1) * 3));
    }

    return arr.join(',') + '₮';
  }
}

@NgModule({ imports: [], declarations: [TugrugPipe], exports: [TugrugPipe] })
export class TugrugPipeModule { }